import { Alert, Col, Form as FormInicial, message, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
    DatePickerItem,
    TextAreaItem,
} from "../../../../Components/Items";

/**
 * Captura opcional de los datos de cada unidad fisica de un activo fijo que se
 * esta recibiendo en una compra.
 *
 * Es puro estado de formulario (mismo patron que AgregarLotes): no guarda nada,
 * devuelve el arreglo por callback y la pantalla que lo abrio lo mete en el
 * renglon (`insumos[i].unidadesActivo`).
 *
 * TODO lo de aqui es opcional. Si el usuario nunca abre este modal, el backend
 * autogenera folio, fecha de adquisicion, proveedor y folio del documento. Un
 * renglon con `numero` vacio consume el contador de folios; uno con `numero`
 * capturado a mano no.
 */
class AgregarUnidadesActivo extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.sembrarUnidades();
        } else if (
            this.props.visible &&
            this.props.cantidad !== prevProps.cantidad
        ) {
            // La cantidad a recibir cambio con el modal abierto: se ajusta el
            // numero de renglones conservando lo ya capturado.
            this.sembrarUnidades();
        }
    }

    sembrarUnidades() {
        const cantidad = Number(this.props.cantidad) || 0;
        const previas = Array.isArray(this.props.unidades) ? this.props.unidades : [];
        const unidadesActivo = [];
        for (let i = 0; i < cantidad; i++) {
            unidadesActivo.push(previas[i] || {});
        }
        this.formRef.current.setFieldsValue({ unidadesActivo });
    }

    cerrarAgregarUnidades() {
        const unidadesActivo = this.formRef.current.getFieldValue("unidadesActivo") || [];

        // Si el usuario capturo folios a mano, no pueden repetirse entre si:
        // el folio es la identidad de la unidad y su codigo de barras.
        const numeros = unidadesActivo
            .map((unidad) => (unidad?.numero || "").toString().trim())
            .filter(Boolean);
        const numerosUnicos = new Set(numeros);
        if (numeros.length !== numerosUnicos.size) {
            message.warning("Hay folios repetidos entre las unidades; cada unidad debe tener un folio distinto");
            return;
        }

        this.props.cerrarAgregarUnidades(unidadesActivo);
        this.formRef.current.resetFields();
    }

    async onFinish() {
        try {
            await this.formRef.current.validateFields();
            this.cerrarAgregarUnidades();
        } catch (error) {
            message.error("Por favor, corrija los errores del formulario antes de continuar.");
        }
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const insumo = this.props.insumo;
        const nombreInsumo = insumo?.descripcion || insumo?.descripcionInsumo || "";
        const codigoInsumo = insumo?.clave ? `${insumo.clave}` : "";
        const tituloExtra = nombreInsumo ? ` : ${codigoInsumo} - ${nombreInsumo} ` : "";
        const cantidad = Number(this.props.cantidad) || 0;

        return (
            <ModalItem
                title={"Unidades de Activo Fijo" + tituloExtra}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.onFinish.bind(this)}
                paddingTop
                width={900}
            >
                <Alert
                    style={{ marginBottom: 10 }}
                    type="info"
                    showIcon
                    message={`Se dara de alta ${cantidad} ${cantidad === 1 ? "unidad" : "unidades"}, una etiqueta por cada una.`}
                    description="Todos los campos son opcionales: el folio se genera automaticamente y la fecha de adquisicion, el proveedor y el folio del documento se toman de la compra. Captura solo lo que quieras dejar registrado por unidad."
                />
                <Form
                    ref={this.formRef}
                    name="agregarUnidadesActivo"
                    layout
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormInicial.List name="unidadesActivo">
                        {(fields) => (
                            <>
                                {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                    <div key={key}>
                                        <HeaderItem>{`UNIDAD ${arrayKey + 1}`}</HeaderItem>
                                        <BoxItem>
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Serie"
                                                        name={[name, "serieActivo"]}
                                                        fieldKey={[fieldKey, "serieActivo"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip={{ title: "Prefijo del folio. Si se deja vacio se usa el del Activo o el de su Tipo de Activo." }}
                                                    >
                                                        <InputItem placeholder="Automatico" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Folio"
                                                        name={[name, "numero"]}
                                                        fieldKey={[fieldKey, "numero"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip={{ title: "Folio de la unidad. Si se deja vacio se toma el siguiente consecutivo automaticamente. Es lo que se imprime como codigo de barras en la etiqueta." }}
                                                    >
                                                        <InputItem placeholder="Automatico" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Ubicacion"
                                                        name={[name, "ubicacionFisica"]}
                                                        fieldKey={[fieldKey, "ubicacionFisica"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip={{ title: "Donde queda fisicamente la unidad (oficina, planta, area). Texto libre." }}
                                                    >
                                                        <InputItem placeholder="Ubicacion fisica" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Fabricante"
                                                        name={[name, "fabricante"]}
                                                        fieldKey={[fieldKey, "fabricante"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip={{ title: "Marca o fabricante del equipo. Texto libre." }}
                                                    >
                                                        <InputItem placeholder="Fabricante" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Fabricacion"
                                                        name={[name, "fechaFabricacion"]}
                                                        fieldKey={[fieldKey, "fechaFabricacion"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip={{ title: "Fecha de fabricacion del equipo, si se conoce. No afecta la depreciacion." }}
                                                    >
                                                        <DatePickerItem placeholder="Fecha de fabricacion" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>
                                                    <FormItem
                                                        {...restField}
                                                        label="Observaciones"
                                                        name={[name, "observaciones"]}
                                                        fieldKey={[fieldKey, "observaciones"]}
                                                        margin
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <TextAreaItem placeholder="Observaciones" autoSize />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </BoxItem>
                                    </div>
                                ))}
                            </>
                        )}
                    </FormInicial.List>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarUnidadesActivo);
